module.exports = __webpack_public_path__ + "static/media/elderberry.0c1ad6b1.png";